import React, { FunctionComponent, useState, Fragment } from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { Box, ClickAwayListener, InputBase, Typography } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons';

interface Props {
    newPetTagName: string;
    petTagCategory: string;
    setNewPetTagName: (name: string) => void;
    onSavePetTagCustom: (petTagCategory: string, newPetTagName: string) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            gap: 12,
            display: 'flex',
            flexWrap: 'wrap',
            alignContent: 'space-around',
            zIndex: 1,

            [theme.breakpoints.up('md')]: {
                gap: 16
            }
        },
        containerForm: {
            position: 'relative',
            width: '180px',
            height: '32px',

            [theme.breakpoints.down('sm')]: {
                width: '100%'
            }
        },
        plusButton: {
            width: 27,
            height: 27,
            cursor: 'pointer'
        },
        formPet: {
            borderRadius: 14,
            overflow: 'hidden',
            border: 'solid 1px #000',
            backgroundColor: 'white',

            [theme.breakpoints.down('sm')]: {
                width: '100%'
            },
            [theme.breakpoints.up('md')]: {
                minWidth: '180px',
                height: '109px'
            }
        },
        containerInput: {
            gap: 6,
            width: '100%',
            height: '60px',
            display: 'flex',
            alignItems: 'center',
            padding: '8px 16px 0px'
        },
        inputTextField: {
            fontFamily: 'Poppins',
            fontSize: '16px',
            fontWeight: 400,
            [theme.breakpoints.down('sm')]: {
                lineHeight: '14px'
            },
            [theme.breakpoints.only('md')]: {
                lineHeight: '18px'
            },
            [theme.breakpoints.only('lg')]: {
                //fontSize: '13px',
                lineHeight: '22px'
            },
            [theme.breakpoints.only('xl')]: {
                //fontSize: '16px',
                lineHeight: '27px'
            }
        },
        addButton: {
            'height': 49,
            'width': '100%',
            'display': 'flex',
            'alignItems': 'center',
            'backgroundColor': '#92B4A7',
            'cursor': 'pointer',

            '&:hover': {
                backgroundColor: '#92B4A7'
            }
        },
        textAddButton: {
            fontSize: 15,
            fontWeight: 500,
            width: '100%',
            color: '#FFFFFF',
            textAlign: 'center'
        }
    })
);

export const TagInput: FunctionComponent<Props> = props => {
    const classes = useStyles();

    const [showForm, setShowForm] = useState(false);

    const openForm = () => {
        props.setNewPetTagName('');
        setShowForm(true);
    };

    const clickSaveHandle = (newPetTagName: string) => {
        setShowForm(false);
        props.onSavePetTagCustom(props.petTagCategory, newPetTagName);
    };

    const inputPetTagCustom = (
        <Box className={classes.containerInput}>
            <Box>
                <InputBase
                    autoFocus={true}
                    className={classes.inputTextField}
                    value={props.newPetTagName}
                    onChange={event => props.setNewPetTagName(event.target.value)}
                    required={true}
                    placeholder="Type Personality"
                />
            </Box>
        </Box>
    );

    const addButtonNew = (
        <Box
            className={classes.addButton}
            onClick={() => clickSaveHandle(props.newPetTagName)}
        >
            <Typography className={classes.textAddButton}>+ Add New</Typography>
        </Box>
    );

    const petTagForm = (
        <Fragment>
            <Box className={classes.containerForm}>
                <ClickAwayListener onClickAway={() => setShowForm(false)}>
                    <Box className={classes.formPet}>
                        {inputPetTagCustom}
                        {addButtonNew}
                    </Box>
                </ClickAwayListener>
            </Box>
        </Fragment>
    );

    const plusButton = (
        <FontAwesomeIcon
            icon={faPlusCircle}
            color="#92B4A7"
            onClick={openForm}
            className={classes.plusButton}
        />
    );

    return (
        <Box
            id="pet_form_add_pet_tag_customcontainer"
            className={classes.container}
        >
            {showForm ? petTagForm : plusButton}
        </Box>
    );
};

export default TagInput;
